import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: '<ng-content></ng-content>'
})
export class FooterComponent {}
